<template>
  <div>
    <el-button
      v-if="admin"
      type="primary"
      size="small"
      v-code="51301"
      @click.native="handleEdit()"
      >添加 {{ commodityCategory.name }} 出库</el-button
    >
    <el-table :data="items">
      <!-- <el-table-column align="center" label="零件名">
        <template slot-scope="scope">
          {{ scope.row.item.name }}（{{ scope.row.item.code }}）
        </template>
      </el-table-column> -->

      <el-table-column
        align="center"
        label="材料名称"
        prop="item.name"
      ></el-table-column>
      <el-table-column
        align="center"
        label="存货编码"
        prop="item.code"
      ></el-table-column>
      <el-table-column
        align="center"
        label="规格"
        prop="item.specification"
      ></el-table-column>
      <!-- <el-table-column
        align="center"
        label="型号"
        prop="model_number"
      ></el-table-column> -->
      <el-table-column
        :label="commodityCategory.id == 2 ? '倒角' : '型号'"
        prop="item.model_number"
        align="center"
      >
      </el-table-column>
      <template v-if="commodityCategory.id == 2">
        <el-table-column label="齿形" prop="item.tooth_type" align="center">
        </el-table-column>
        <el-table-column label="尺寸" prop="item.size" align="center">
        </el-table-column>
      </template>
      <el-table-column
        align="center"
        label="单位"
        prop="item.unit"
      ></el-table-column>

      <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column>
      <el-table-column align="center" label="钻头">
        <template slot-scope="scope">
          <div
            v-for="no in scope.row.drill_serial_numbers.split(',')"
            :key="no"
            v-if="scope.row.drill_serial_numbers"
          >
            <DrillLink :no="no"></DrillLink>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="备注"
        prop="remark"
      ></el-table-column>
      <el-table-column label="出库类型" align="center">
        <template slot-scope="scope">
          {{ ItemStockOutCategoryMap[scope.row.stock_out_category] }}
        </template>
      </el-table-column>
      <el-table-column label="出库时间" align="center" min-width="90">
        <template slot-scope="scope">
          {{
            scope.row.confirm_time
              ? $time(scope.row.confirm_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span
            class="label"
            :class="scope.row.status == 1 ? 'label-warning' : 'label-success'"
          >
            {{ scope.row.status == 1 ? '未出库' : '已出库' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 1">
            <template v-if="admin">
              <btn-tag
                :btn="true"
                text="编辑"
                :key="Math.random()"
                :auth-id="51301"
                module-name="stock"
                @click.native="handleEdit(scope.row, scope.$index)"
              ></btn-tag>
              <btn-tag
                :btn="true"
                text="删除"
                :key="Math.random()"
                :auth-id="51301"
                module-name="stock"
                btn-class="btn-danger"
                @click.native="hanldeDelte(scope.row, scope.$index)"
              ></btn-tag>
              <btn-tag
                :btn="true"
                text="确认出库"
                :key="Math.random()"
                :auth-id="51301"
                module-name="stock"
                btn-class="btn-warning"
                @click.native="hanldeConfirmStockOut(scope.row, scope.$index)"
              ></btn-tag>
            </template>
          </template>
          <template v-else>
            <button
              v-if="scope.row.logistic_number"
              class="btn btn-sm btn-labeled btn-rounded btn-default"
              @click="drillDeliveryDetail(scope.row)"
            >
              物流信息
            </button>
            <!-- <btn-tag
              :btn="true"
              text="详情"
              :key="Math.random()"
              :auth-id="51301"
              module-name="stock"
              @click.native="handleShow(scope.row)"
            ></btn-tag> -->
          </template>
        </template>
      </el-table-column>
    </el-table>

    <item-out-former
      :model="model"
      :commodityCategory="commodityCategory"
      :show.sync="formerVisible"
      @callback="callback"
    ></item-out-former>
    <item-detail :model="model" :show.sync="detailVisible"></item-detail>
    <delivery-info
      :model="model"
      :show.sync="formerDeliveryVisible"
    ></delivery-info>
  </div>
</template>

<script>
import { itemOutRecordDelete, itemOutRecordConfirm } from '@/service/getData'
import itemOutFormer from '@/components/item_out_former'
import ItemDetail from '@/components/item_out_record_detail'
import DeliveryInfo from '@/components/delivery_info'
import { ItemStockOutCategoryMap } from '../../../../config/global'

export default {
  components: {
    itemOutFormer,
    ItemDetail,
    DeliveryInfo,
  },
  props: {
    items: null,
    admin: false,
    commodityCategory: Object,
  },
  data() {
    return {
      ItemStockOutCategoryMap,
      model: {
        item_id: '',
        category: 1,
        number: 1,
        drills: [],
        remark: '',
        logistic_company: '',
        logistic_number: '',
        receiver_mobile: '',
      },
      formerVisible: false,
      detailVisible: false,
      formerDeliveryVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    handleShow(item) {
      this.model = item
      this.detailVisible = true
    },

    handleEdit(item, index) {
      this.formerVisible = true
      this.$nextTick(() => {
        if (!item) {
          this.editIndex = -1
          this.model = {
            item_id: '',
            commodity_category: this.commodityCategory.id,
            stock_out_category: 1,
            category: 2,
            number: 1,
            drills: [],
            remark: '',
            logistic_company: '',
            logistic_number: '',
            receiver_mobile: '',
            created: true,
          }
        } else {
          this.model = this.clone(item)
          this.model.drills = item.drill_serial_numbers
            ? item.drill_serial_numbers.split(',')
            : []
          this.model.created = true
          this.editIndex = index
        }
      })
    },

    editItem(item, index) {
      this.editIndex = index
      this.formerVisible = true

      let drills = []
      if (item.drill_serial_numbers) {
        drills = item.drill_serial_numbers.split(',') || []
      }
      this.$nextTick(() => {
        this.model = {
          id: item.id,
          item_id: item.item_id,
          number: item.number,
          drills: drills,
          remark: item.remark,
          logistic_company: item.logistic_company,
          logistic_number: item.logistic_number,
          receiver_mobile: item.receiver_mobile,
        }
      })
    },

    drillDeliveryDetail(item) {
      this.model = item
      this.formerDeliveryVisible = true
    },
    callback(data) {
      if (this.editIndex == -1) {
        this.items.unshift(data)
      } else {
        this.$set(this.items, this.editIndex, data)
      }
    },

    hanldeConfirmStockOut(item, index) {
      let that = this
      this.$confirm('确认出库吗?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await itemOutRecordConfirm(item.id)
          if (res.status == 0) {
            that.$set(that.items, index, res.data)
          }
        })
        .catch(() => {})
    },

    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        itemOutRecordDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>